import { MultiStepFormConfig, BaseFormData } from './components/types';
import { CriteriaWithSelectionStep, StaticContentStep } from './steps';
import { createFormOptions } from './steps/baseFormOptions';
import { createFormValidations } from './steps/baseFormValidations';
import { 
  criteriaWithSelectionStepInitialData, 
  combineStepData 
} from './steps/initialData';

// Form options for Buyer Protection
export const formOptions = createFormOptions({
  buyerProtectionCriteria: [
    {
      value: "yes",
      title: "Yes",
      description: "We use Octet’s Debtor & Invoice Finance solution."
    },
    {
      value: "no",
      title: "No",
      description: "We don’t currently use Debtor & Invoice Finance."
    }
  ],
});

export const formValidations = createFormValidations({
  // Buyer Protection specific validations
  criteriaSelection: (data: BaseFormData) => !!data.criteriaSelection,
});

// Combine initial data from all steps
const initialFormData = combineStepData(
  criteriaWithSelectionStepInitialData,
);

export const buyerProtectionEnquireFormConfig: MultiStepFormConfig<BaseFormData> = {
  formId: 'buyer-protection-enquire',
  formOptions: formOptions,
  steps: [
    {
      id: 'criteria-check',
      title: 'Quick suitability check.',
      description: 'Let\'s check if <strong>Buyer Protection</strong> is right for your business.',
      component: CriteriaWithSelectionStep,
      validation: formValidations.criteriaSelection,
      selectionQuestion: "Do you currently use Octet’s <a href='/products/debtor-and-invoice-finance' target='_blank'>Debtor & Invoice Finance</a>?",
      selectionOptions: formOptions.buyerProtectionCriteria,
      // infoBoxText: "Buyer Protection (also referred to as Bad Debt Protection) is available to businesses with an active <a href='/products/debtor-and-invoice-finance'>Debtor & Invoice Finance</a> facility. If you’re not yet using one, you’re still welcome to complete the form and we’ll help guide you to the right solution for your business.",
      noSelectionRedirectToThankYou: true,
      noSelectionRedirectToThankValue: "yes",
      showThankYouWithoutSubmit: true,
      noSelectionThankYouConfig: {
        title: 'Thanks for letting us know',
        subtitle: 'As an existing client, your <strong>Relationship Manager</strong> is best placed to help you set up Buyer Protection tailored to your <a href="/products/debtor-and-invoice-finance">Debtor & Invoice Finance</a> facility.',
        firstName: '',
        nextStepsTitle: 'Here are the next steps:',
        businessName: '',
        nextStepsItems: [
          {
            icon: 'quick_reference_all',
            text: 'Review your debtor list to identify high-risk or high-value accounts.',
          },
          {
            icon: 'contact_support',
            text: 'Contact your Relationship Manager directly to discuss your eligibility and options or simply call us on <a href="tel:1300862838">1300 862 838</a>.',
          },
          {
            icon: 'check_circle',
            text: 'We’ll help tailor the protection coverage based on your business needs.'
          }
        ],
        ctaButton: {
          text: 'View Homepage',
          href: '/'
        },
        additionalInfo: 'In the meantime, stay in-the-know with helpful trends, insights and business guides.',
        socialButton: {
          text: 'Follow Octet on LinkedIn',
          href: 'https://www.linkedin.com/company/octet-finance'
        }
      },
    },
    {
      id: 'buyer-protection-info',
      title: 'Available with Debtor & Invoice Finance.',
      description: '<strong>Buyer Protection</strong> is available when paired with an Octet <a href="/products/debtor-and-invoice-finance" target="_blank" class="text-primary underline">Debtor & Invoice Finance</a> facility. This combination protects your business from customer non-payment and strengthens your cash flow.',
      component: StaticContentStep,
      isOptional: true, // This step doesn't require form submission
      stepConfig: {
        ctaButton: {
          text: 'Continue with Debtor & Invoice Finance',
          href: '/enquire/debtor-invoice-finance',
          variant: 'primary',
          size: 'lg'
        },
        disclaimerText: "We'll redirect you to the Debtor & Invoice Finance enquiry form",
      },
      // shouldShow: (data: BaseFormData) => data.criteriaSelection === 'no',
    },
   
  ],
  initialData: initialFormData,
  onSubmit: async () => {
  },
  hideSubmitButton: true,
  showProgress: true,
  allowBackNavigation: true,
  onStepChange: (currentStep, totalSteps) => {
    console.info(`Buyer Protection form: Step ${currentStep} of ${totalSteps}`);
  },
};
